"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUscisEmploymentEligibilityCategory = exports.ELIGIBILITY_CATEGORIES = void 0;
exports.ELIGIBILITY_CATEGORIES = {
  A_5: "(a)(5)",
  C_8: "(c)(8)"
}; // Eligibility Categories for Work Permits
// https://www.uscis.gov/working-in-the-united-states/information-for-employers-and-employees/employer-information/employment-authorization

var getUscisEmploymentEligibilityCategory = function getUscisEmploymentEligibilityCategory(_ref) {
  var isApplyingForAsylum = _ref.isApplyingForAsylum,
      wasAsylumApplicationApproved = _ref.wasAsylumApplicationApproved;

  // --- (a)(5)
  if (wasAsylumApplicationApproved) {
    return exports.ELIGIBILITY_CATEGORIES.A_5;
  } // --- (c)(8)


  if (isApplyingForAsylum) {
    return exports.ELIGIBILITY_CATEGORIES.C_8;
  } // ???


  return null;
};

exports.getUscisEmploymentEligibilityCategory = getUscisEmploymentEligibilityCategory;